import { Skeleton, Typography, styled, useTheme } from '@mui/material';
import { kebabCase } from 'lodash-es';
import { Fragment } from 'react';
import { type CastRole, type CrewJob } from '#enums/castAndCrew.ts';
import { tt } from '#i18n/index.ts';

export const Container = styled('div')(() => ({
  'div:last-child': {
    marginBottom: 0,
  },
}));

export const HighlightContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
}));

export type ComponentProps = {
  highlights: [CastRole | CrewJob, string][];
};

export const Component = ({ highlights }: ComponentProps) => {
  const theme = useTheme();

  return (
    <Container>
      {highlights.length > 0 ? (
        highlights.map(([role, names]) => (
          <HighlightContainer key={kebabCase(role)}>
            <Typography
              sx={{
                color: theme.supportingTextPrimary,
                fontSize: '0.75rem',
                textTransform: 'uppercase',
              }}
            >
              {tt(`castAndCrew.subTitles.${role}`)}
            </Typography>
            <Typography
              sx={{
                color: theme.mainTextPrimary,
              }}
            >
              {names}
            </Typography>
          </HighlightContainer>
        ))
      ) : (
        <HighlightContainer>
          {Array.from({ length: 3 }).map((_, index) => (
            <Fragment key={index}>
              <Skeleton sx={{ fontSize: '0.75rem' }} variant="text" width={80} />
              <Skeleton sx={{ fontSize: '1rem' }} variant="text" width={250} />
            </Fragment>
          ))}
        </HighlightContainer>
      )}
    </Container>
  );
};
